import TypeaheadController from '../typeahead_controller';

export default class ConcernsPersonSearchController extends TypeaheadController {
  onSelection(feedback) {
    const { selection: { value: { partials: { concern: concernHtml } } } } = feedback;
    const personSelectedEvent = new CustomEvent('concern_form:person_selected', { bubbles: true, detail: { concernHtml } });
    this.element.dispatchEvent(personSelectedEvent);
  }
}
